import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const CallToAction = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        // Degradado actualizado con tu nuevo color corporativo #1A237E
        background: 'linear-gradient(135deg, #1A237E 0%, #101652 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background Pattern discreto */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.06,
          backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
          backgroundSize: '50px 50px',
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="overline"
            sx={{
              color: 'rgba(255, 255, 255, 0.7)', // Blanco suave para el subtítulo superior
              fontWeight: 600,
              fontSize: '0.9rem',
              letterSpacing: 2,
            }}
          >
            START YOUR JOURNEY
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.2rem', md: '3.2rem' },
              fontWeight: 700,
              color: '#ffffff', // Blanco puro para máxima lectura
              mt: 2,
              mb: 3,
              lineHeight: 1.3,
              fontFamily: '"Playfair Display", serif',
            }}
          >
            For Better Future. Learn Better Education
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'rgba(255, 255, 255, 0.8)', // Texto de párrafo limpio
              fontSize: { xs: '1rem', md: '1.1rem' },
              mb: 4,
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.8,
            }}
          >
            Join thousands of students who have transformed their lives through our
            comprehensive learning programs. Start your journey to success today.
          </Typography>

          <Button
            variant="contained"
            size="large"
            endIcon={<ArrowForwardIcon />}
            sx={{
              backgroundColor: '#E53935', // Botón con tu Rojo corporativo
              color: '#ffffff', // Texto en blanco para alto contraste
              px: 5,
              py: 2,
              fontSize: '1.1rem',
              fontWeight: 600,
              borderRadius: 50,
              boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
              '&:hover': {
                backgroundColor: '#0D134A', // Un tono azul más oscuro para que contraste sobre el fondo nuevo
                transform: 'translateY(-3px)',
                boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
              },
              transition: 'all 0.3s ease',
            }}
            href="/about-us/admissions"
          >
            Contact Us
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CallToAction;